import { createElement } from 'react';
import PropTypes from 'prop-types';

const defaultClasses = {
  1: 'headline-3 u-bold',
  2: 'headline-5 u-bold',
  3: 'body-3 u-bold',
  4: 'body-4 u-bold',
  5: '',
  6: ''
};

const header = size => {
  const Header = ({ className = '', useBareClass, children, ...props }) =>
    createElement(
      `h${size}`,
      {
        ...props,
        className: useBareClass ? className : `${defaultClasses[size]} ${className}`
      },
      children
    );
  Header.defaultProps = {
    className: '',
    useBareClass: false
  };

  Header.propTypes = {
    className: PropTypes.string,
    useBareClass: PropTypes.bool,
    children: PropTypes.node.isRequired
  };

  return Header;
};

export const H1 = header(1);
export const H2 = header(2);
export const H3 = header(3);
export const H4 = header(4);
export const H5 = header(5);
export const H6 = header(6);
